<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="onClose"><span class="blind">X</span></button>
      <h2 class="layerTitle">{{locale.confirm_delete_code}}</h2>
      <div class="formGroup">
        <div class="message mb30">
          <!-- <p>{{locale.code_delete_message1}}</p> -->
          <p class="colorRed">{{locale.code_delete_message3}}</p>
          <p class="mt10">{{locale.code_delete_message2}}</p>
        </div>
        <div class="deleteme">
          <input type="text" class="input"
            :placeholder="placeholder"
            @keyup.enter="validateOnDel"
            v-model="input" />
            <p v-if="message !== ''" class="colorRed mt5">{{message}}</p>
        </div>
        <div class="multiBtn mt30">
          <button type="button" class="btn btnColumn sizeL btnWhite" @click="onClose">{{locale.cancel}}</button>
          <button type="button" class="btn btnColumn sizeL btnPrimary" @click="validateOnDel">{{locale.delete}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CodeDelete',
  props: [
    'locale'
  ],
  data () {
    return {
      placeholder: 'DELETE ME',
      input: '',
      message: ''
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    },
    validateOnDel () {
      if (this.placeholder !== this.input) {
        this.message = this.locale.validate_delete_me
      } else {
        if (window.confirm(this.locale.confirm_delete_code)) {
          this.$emit('delete')
          this.$emit('close')
          this.message = ''
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer .formGroup {
  padding: 60px 30px;
}
.message {
  text-align: center;
  font-size: 1.2em;
}
.deleteme {
  margin: 0 auto 30px;
  text-align: center;
  .input {
    max-width: 200px;
    text-align: center;
    font-size: 1.8em;
    font-weight: bold;
  }
}
.formGroup .multiBtn {
  padding: 0 30px;
}
</style>
